"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var _external = require("../external");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    palette = _ref.palette;
  return {
    root: function root(_ref2) {
      var _palette$variant$main, _palette$variant;
      var variant = _ref2.variant;
      var color = (_palette$variant$main = (_palette$variant = palette[variant]) === null || _palette$variant === void 0 ? void 0 : _palette$variant.main) !== null && _palette$variant$main !== void 0 ? _palette$variant$main : '#626262';
      var textColor = color;
      var backgroundColor = (0, _external.fade)(color, 0.1);
      if (variant === 'warning') {
        textColor = 'rgb(16, 16, 16, 0.8)';
        backgroundColor = (0, _external.fade)(color, 0.3);
      }
      if (variant === 'orange') {
        textColor = '#CF752F';
        backgroundColor = 'rgba(207, 117, 47, 0.10)';
      }
      return {
        backgroundColor: backgroundColor,
        color: textColor,
        fontSize: '11px',
        lineHeight: '15px',
        letterSpacing: '1.65px',
        fontWeight: typography.fontWeightSemiBold,
        textTransform: 'uppercase',
        display: 'inline-block',
        padding: '8px 16px',
        borderRadius: 4
      };
    }
  };
}, {
  name: 'Status'
});
exports.useStyles = useStyles;